<template>
  <div>
    <QBtn
      ref="btn"
      flat
      round
      text-color="primary"
      :icon="icon"
      class="contact-us-button"
      :ripple="false"
    >
    </QBtn>

    <QMenu
      content-class="full-width contact-us bg-application-primary no-border"
      square
    >
      <QList class="contact-us-content" :style="cssProps">
        <QItem>
          <div class="row full-width text-center items-center">
            <SAILink
              :label="orgContactEmail"
              :href="`mailto:${orgContactEmail}`"
              target="_blank"
              color="white"
              class="text-paragraph"
              v-if="orgContactEmail"
            />
            <QSeparator vertical class="q-mx-lg" color="grey-8" />
            <SAILink
              :label="orgContactPhone"
              :href="`tel:${orgContactPhone}`"
              target="_blank"
              color="white"
              class="text-paragraph"
              v-if="orgContactPhone"
            />
          </div>
        </QItem>
      </QList>
    </QMenu>
  </div>
</template>

<script>
import { QBtn, QMenu, QList, QItem, QSeparator } from 'quasar';
import SAILink from '../../atom/sai-link';

export default {
  name: 'SAIContactUsMenu',
  props: {
    orgContactEmail: String,
    orgContactPhone: String,
    icon: {
      type: String,
      default: 'eva-phone-outline'
    }
  },
  data() {
    return {
      pointerPstn: 0
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.pointerPstn = this.$refs.btn.$el.getBoundingClientRect().left;
    });
  },
  computed: {
    cssProps() {
      return {
        '--pointer-left': `${this.pointerPstn + 12}px`
      };
    }
  },
  components: {
    QBtn,
    QList,
    QItem,
    QMenu,
    QSeparator,
    SAILink
  }
};
</script>

<style lang="sass">
.contact-us-button .eva-phone-outline
  font-size: 24px

.contact-us
  margin-top: 8px !important
  left: 0 !important
  right: 0 !important
  max-width: 100% !important
  width: 100% !important
  overflow: visible

.contact-us-content:after
  content: ''
  width: 16px
  height: 16px
  background: $application-primary
  position: absolute
  top: calc(100% - 56px)
  transform: rotate(45deg)
  left: var(--pointer-left)
</style>
